import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { INITIAL_FEATURES } from '../../data/createClubData';

export default function Step5Features({ formData, toggleFeature }) {
  return (
          <Card>
            <CardHeader>
              <CardTitle>Club Features</CardTitle>
              <CardDescription>Choose which features to enable for your club. You can change these later.</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {INITIAL_FEATURES.map(feature => {
                  const Icon = feature.icon;
                  const isSelected = formData.features.includes(feature.id);
                  return (
                    <div
                      key={feature.id}
                      className={`flex items-center gap-3 p-4 rounded-lg border cursor-pointer transition-all ${
                        isSelected ? 'bg-primary/10 border-primary' : 'hover:bg-muted'
                      }`}
                      onClick={() => toggleFeature(feature.id)}
                    >
                      <Checkbox 
                        checked={isSelected} 
                        onCheckedChange={() => toggleFeature(feature.id)}
                        data-testid={`feature-${feature.id}`}
                      />
                      <Icon className={`w-5 h-5 ${isSelected ? 'text-primary' : 'text-muted-foreground'}`} />
                      <span className="font-medium">{feature.label}</span>
                    </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>
  );
}
